module.exports = "<p>\n  auth works!\n</p>\n"